import { render } from "./Board-of-Regents.vue?vue&type=template&id=718f6950&scoped=true"
import script from "./Board-of-Regents.vue?vue&type=script&lang=js"
export * from "./Board-of-Regents.vue?vue&type=script&lang=js"

import "./Board-of-Regents.vue?vue&type=style&index=0&id=718f6950&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2068151293/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718f6950"]])

export default __exports__